import { useContext } from 'react'

import { StringsContext } from '@lib/strings-context'
import { getLinkPageUrl } from '@lib/routes'
import { UserContext } from '@lib/user/context'

import { type ButtonProps } from '@components/buttons/button'
import ButtonLink from '@components/buttons/button-link'

type SharedButtonProps = Pick<
  ButtonProps,
  'variant' | 'size' | 'color' | 'hideLabelUntil' | 'icon'
>

const AccountButton = () => {
  const strings = useContext(StringsContext)
  const { user } = useContext(UserContext)

  const sharedButtonProps: SharedButtonProps = {
    variant: 'outlined',
    size: 'small',
    color: 'gray',
    hideLabelUntil: 'md',
    icon: 'User',
  }

  if (!user) {
    return <ButtonLink {...sharedButtonProps} />
  }

  const loginPageUrl = getLinkPageUrl({
    pageType: 'loginPage',
  })
  const accountPageUrl = getLinkPageUrl({
    pageType: 'accountPage',
  })

  if (!user.isLoggedIn) {
    return (
      <ButtonLink
        {...sharedButtonProps}
        href={loginPageUrl}
        iconAlignment="right"
      >
        {strings.buttonLogin}
      </ButtonLink>
    )
  }

  return (
    <ButtonLink
      {...sharedButtonProps}
      href={accountPageUrl}
      iconAlignment="left"
    >
      {user.customer
        ? `${user.customer?.firstName.charAt(0)}. ${user.customer?.lastName}`
        : ''}
    </ButtonLink>
  )
}

export default AccountButton
